import { matchPath } from 'react-router-dom'
import pageTitles from '@routing/gamePageTitles'

export function pageTitle(pathname: string) {
  const userMatch = matchPath('/users/:uid/*', pathname)

  if (userMatch) {
    const uid = userMatch.params.uid ?? ''
    return uid ? `Игрок #${uid}` : 'Карточка игрока'
  }

  return (
    pageTitles.find(({ path }) => matchPath(path, pathname))?.title ??
    'Статистика'
  )
}
